import { formatRequest } from "../../utils/function";
import axiosInstance from "../axiosInstance";

export function createlogin(data) {
  return axiosInstance.post(`/login`, formatRequest(data));
}

export function createAdminLogin(data) {
  return axiosInstance.post(`/admin/login`, formatRequest(data));
}

export function createSignup(data) {
  return axiosInstance.post(`/sign-up`, formatRequest(data));
}

export function updateProfile(data) {
  return axiosInstance.post(`/update-profile`, formatRequest(data));
}

export function getProfileDetails() {
  return axiosInstance.get(`/profile-details`);
}



